import {
  Text,
  TextFonts,
  TextProps,
  TextTheme,
  TextWrappers,
  TextSizes,
  TextLineHeights,
} from ".";
import React from "react";
import { ComponentInterfaceBaseClass } from "@att-bit/duc.utils-ts.types";

export interface TextRuntimeProps {
  // TODO, can this go to a base interface?
  themetext?: TextTheme;
}

export class TextInterface
  extends ComponentInterfaceBaseClass
  implements TextProps
{
  key;
  children;
  color;
  wrapper;
  font;
  lineHeight;
  size;
  allowDangerousHtml;
  className;
  bulletType;
  margin;
  legalData;
  linkAnalyticsObj;
  enableLinkAnalytics;
  tooltipData;
  static initWithSanity(key, feed) {
    const t = new TextInterface();
    const config = feed?.configs || {};
    // config.font = 'font-italic';
    t.key = key;
    t.children = feed?.text;
    t.color = config?.color;
    /* eslint-disable @typescript-eslint/no-explicit-any */
    t.size = feed?.size
      ? feed.size
      : config?.size
      ? (Object as any).values(TextSizes).includes(config.size) && config.size
      : undefined;
    t.wrapper =
      ((Object as any).values(TextWrappers).includes(config.wrapper) &&
        config.wrapper) ||
      undefined;
    t.font =
      ((Object as any).values(TextFonts).includes(config.font) &&
        config.font) ||
      undefined;
    t.lineHeight =
      ((Object as any).values(TextLineHeights).includes(config.lineHeight) &&
        config.font) ||
      undefined;
    t.bulletType = config?.bulletType || undefined;
    t.margin = config?.margin || undefined;
    /* eslint-enable @typescript-eslint/no-explicit-any */
    t.className = config?.className;
    if (feed?.legal || (feed?.textContent && feed.textContent?.legal)) {
      t.legalData = feed?.legal ? feed.legal : feed?.textContent?.legal;
    }
    if (feed?.tooltip || feed?.textContent && feed.textContent?.tooltip) {
      t.tooltipData = feed.tooltip ? feed.tooltip : feed?.textContent?.tooltip;
    } else {
      t.allowDangerousHtml = true;
    }
    t.linkAnalyticsObj = feed.linkAnalyticsObj;
    t.enableLinkAnalytics = true;
    return t;
  }
  toProps(themetext?): TextProps {
    const props = {
      key: this.key,
      color: this.color, // || theme?.color || standardTextDataThemes[this.key]?.color,
      size: this.size,
      font: this.font,
      lineHeight: this.lineHeight,
      children: this.children,
      allowDangerousHtml: this.allowDangerousHtml,
      wrapper: this.wrapper,
      className: this.className,
      bulletType: this.bulletType,
      margin: this.margin,
      themetext: themetext,
      legalData: this.legalData,
      linkAnalyticsObj: this.linkAnalyticsObj,
      enableLinkAnalytics: this.enableLinkAnalytics,
      tooltipData: this.tooltipData,
    };
    return props;
  }
  toJsx(runtimeProps?: TextRuntimeProps): JSX.Element {
    return React.createElement(Text, {
      ...this.toProps(runtimeProps),
      ...runtimeProps,
    });
  }
}
